import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages1Alt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImages1Alt"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM4.5 15.5V19.5H15.5L8 12L4.5 15.5ZM15 6.5C13.6193 6.5 12.5 7.61929 12.5 9C12.5 10.3807 13.6193 11.5 15 11.5C16.3807 11.5 17.5 10.3807 17.5 9C17.5 7.61929 16.3807 6.5 15 6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImages1Alt;
